import { Injectable, Pipe, PipeTransform } from "@angular/core";
import { LoadBalancingStrategyAbbreviation } from "app/features/nconnect-voice/components/trunkset/trunkset-modal/trunkset-modal.component";

@Pipe({
  name: "loadbalancingStrategy",
  standalone: false,
})
@Injectable({
  providedIn: "root",
})
export class LoadbalancingStrategyPipe implements PipeTransform {
  public transform(
    loadbalancingStrategy: LoadBalancingStrategyAbbreviation,
  ): string {
    // It's ok to have here no translations
    switch (loadbalancingStrategy) {
      case "pb":
        return "Primary / Backup";
      case "rr":
        return "Round-Robin";
      case "ra":
        return "Forking";
      default:
        return "-";
    }
  }
}
